import { Icon } from "@iconify/react";
import { FaCube, FaCaretDown, FaCaretRight } from "react-icons/fa";

export const getNavItems = (role) => {

    if (role === "StoreCreator") {
        return [
            {
                path: "/stores",
                label: "Store",
                icon: <Icon icon="mdi:store" width="20" height="20" />,
                subItems: [{
                    path: "/store-admin",
                    label: "Store Admin",
                    icon: <Icon icon="mdi:account" width="20" height="20" />,
                }]
            },
            {
                path: "/logout",
                label: "Logout",
                icon: <Icon icon="mdi:logout-variant" width="20" height="20" />,
            },
        ];
    }

    if (role === "Accountant") {
        return [
            {
                path: "/sales",
                label: "Sales",
                icon: <Icon icon="mdi:graph-line" width="20" height="20" />,
            },
            {
                path: "/purchases",
                label: "Purchase",
                icon: <Icon icon="mdi:shopping-cart-arrow-down" width="20" height="20" />,
            },
            {
                path: "/expense",
                label: "Expense",
                icon: <Icon icon="mdi:money-100" width="20" height="20" />,
            },
            {
                path: "/sales-report",
                label: "Sales Report",
                icon: <Icon icon="mdi:finance" width="20" height="20" />,
            },
            {
                path: "/reports",
                label: "Reports",
                icon: <Icon icon="mdi:report-areaspline" width="20" height="20" />,
                subItems: [
                    {
                        path: "/reports/staff-sales",
                        label: "Staff Sales Report",
                        icon: <Icon icon="mdi:finance" width="18" height="18" />,
                    },
                    {
                        path: "/reports/customer",
                        label: "Customer Report",
                        icon: <Icon icon="mdi:account-multiple" width="18" height="18" />,
                    },
                    {
                        path: "/reports/eod",
                        label: "EOD Report",
                        icon: <Icon icon="mdi:file-document-check" width="18" height="18" />,
                    },
                    {
                        path: "/reports/appointment",
                        label: "Appointment Report",
                        icon: <Icon icon="mdi:calendar-check" width="18" height="18" />,
                    },
                    {
                        path: "/reports/expense",
                        label: "Expense Report",
                        icon: <Icon icon="mdi:cash-multiple" width="18" height="18" />,
                    },
                    {
                        path: "/reports/profit-loss",
                        label: "Profit & Loss Report",
                        icon: <Icon icon="mdi:finance" width="18" height="18" />,
                    },
                    {
                        path: "/reports/purchase",
                        label: "Purchase Report",
                        icon: <Icon icon="mdi:shopping-cart" width="18" height="18" />,
                    },
                    {
                        path: "/reports/summary",
                        label: "Summary Report",
                        icon: <Icon icon="mdi:file-chart" width="18" height="18" />,
                    },
                    {
                        path: "/wallets",
                        label: "Wallet Reports",
                        icon: <Icon icon="solar:wallet-money-bold-duotone" width="18" height="18" />,
                    }
                ]
            },
            {
                path: "/logout",
                label: "Logout",
                icon: <Icon icon="mdi:logout-variant" width="20" height="20" />,
            },
        ];
    }

    // 👑 All other roles
    return [
        ...(role === "SuperAdmin" ||
            role === "FranchiseAdmin" ||
            role === "ClusterManager" ||
            role === "StoreAdmin" ||
            role === "SelfAdmin" ||
            role === "StoreManager" ||
            role === "Manager"
            ? [
                {
                    path: "/dashboard",
                    label: "Dashboard",
                    icon: <Icon icon="mdi:view-dashboard-edit-outline" width="20" height="20" />,
                },
                {
                    path: "/pos",
                    label: "POS",
                    icon: <Icon icon="mdi:cash-register" width="20" height="20" />,
                },
                {
                    path: "/products",
                    label: "Products",
                    icon: <FaCube style={{ fontSize: '16px' }} />,
                    subItems: [
                        {
                            path: "/products/category",
                            label: "Category",
                            icon: <Icon icon="mdi:category-plus" width="20" height="20" />,
                        },
                        {
                            path: "/products/sub-category",
                            label: "Sub Category",
                            icon: <Icon icon="mdi:category" width="20" height="20" />,
                        },
                    ],
                },
                {
                    path: "/services",
                    label: "Services",
                    icon: <Icon icon="mdi:tag" width="20" height="20" />,
                    subItems: [
                        {
                            path: "/services/category",
                            label: "Category",
                            icon: <Icon icon="mdi:category-plus" width="20" height="20" />,
                        },
                        {
                            path: "/services/sub-category",
                            label: "Sub Category",
                            icon: <Icon icon="mdi:category" width="20" height="20" />,
                        },
                    ],
                },
                ...(role === "SuperAdmin" || role === "SelfAdmin"
                    ? [
                        {
                            path: "/stores",
                            label: "Store",
                            icon: <Icon icon="mdi:store" width="20" height="20" />,
                            subItems: [{
                                path: "/store-admin",
                                label: "Store Admin",
                                icon: <Icon icon="mdi:account" width="20" height="20" />,
                            }]
                        },
                        {
                            path: "/users",
                            label: "TVFM Users",
                            icon: <Icon icon="mdi:account" width="20" height="20" />,
                        },
                        {
                            path: "/package-management",
                            label: "POS Package Management",
                            icon: <Icon icon="mdi:package-variant-closed" width="20" height="20" />,
                        },
                        {
                            path: "/subscription-history",
                            label: "Store Subscriptions",
                            icon: <Icon icon="mdi:store-check" width="20" height="20" />,
                        },
                        {
                            path: "/pos-usage-history",
                            label: "POS Usage History",
                            icon: <Icon icon="mdi:history" width="20" height="20" />,
                        },
                    ]
                    : []),
                ...(role === "SuperAdmin" || role === "SelfAdmin"
                    ? [
                        {
                            path: "/franchisor",
                            label: "Franchisor",
                            icon: <Icon icon="mdi:house-group-add" width="20" height="20" />,
                            subItems: [
                                {
                                    path: "/franchisor-admin",
                                    label: "Franchisor Admin",
                                    icon: <Icon icon="mdi:account" width="20" height="20" />,
                                },
                            ],
                        },
                        {
                            path: "/appearance/background",
                            label: "Login Background",
                            icon: <Icon icon="mdi:image-multiple-outline" width="20" height="20" />,
                        },
                        {
                            path: "/appearance/stock-images",
                            label: "Stock Images",
                            icon: <Icon icon="mdi:image-album" width="20" height="20" />,
                        },
                        {
                            path: "/settings/legal-documents",
                            label: "Settings",
                            icon: <Icon icon="mdi:cog-outline" width="20" height="20" />,
                            subItems: [
                                {
                                    path: "/settings/legal-documents/privacy-policy",
                                    label: "Privacy Policy",
                                    icon: <Icon icon="mdi:file-document-outline" width="18" height="18" />,
                                },
                                {
                                    path: "/settings/legal-documents/terms-and-conditions",
                                    label: "Terms & Conditions",
                                    icon: <Icon icon="mdi:file-certificate-outline" width="18" height="18" />,
                                },
                            ],
                        },
                    ]
                    : []),

                ...(role !== "Manager" ? [
                    {
                        path: "/employees",
                        label: "Employees",
                        icon: <Icon icon="mdi:account-group" width="20" height="20" />,
                    },
                ] : []),
                {
                    path: "/customers",
                    label: "Customers",
                    icon: <Icon icon="mdi:people" width="20" height="20" />,
                },
                {
                    path: "/reports",
                    label: "Reports",
                    icon: <Icon icon="mdi:report-areaspline" width="20" height="20" />,
                    subItems: [
                        {
                            path: "/reports/sales",
                            label: "Sales Report",
                            icon: <Icon icon="mdi:finance" width="18" height="18" />,
                        },
                        {
                            path: "/reports/staff-sales",
                            label: "Staff Sales Report",
                            icon: <Icon icon="mdi:finance" width="18" height="18" />,
                        },
                        {
                            path: "/reports/customer",
                            label: "Customer Report",
                            icon: <Icon icon="mdi:account-multiple" width="18" height="18" />,
                        },
                        {
                            path: "/reports/eod",
                            label: "EOD Report",
                            icon: <Icon icon="mdi:file-document-check" width="18" height="18" />,
                        },
                        {
                            path: "/reports/appointment",
                            label: "Appointment Report",
                            icon: <Icon icon="mdi:calendar-check" width="18" height="18" />,
                        },
                        {
                            path: "/reports/expense",
                            label: "Expense Report",
                            icon: <Icon icon="mdi:cash-multiple" width="18" height="18" />,
                        },
                        {
                            path: "/reports/profit-loss",
                            label: "Profit & Loss Report",
                            icon: <Icon icon="mdi:finance" width="18" height="18" />,
                        },
                        {
                            path: "/reports/purchase",
                            label: "Purchase Report",
                            icon: <Icon icon="mdi:shopping-cart" width="18" height="18" />,
                        },
                        {
                            path: "/reports/summary",
                            label: "Summary Report",
                            icon: <Icon icon="mdi:file-chart" width="18" height="18" />,
                        },
                        {
                            path: "/wallets",
                            label: "Wallet Reports",
                            icon: <Icon icon="solar:wallet-money-bold-duotone" width="18" height="18" />,
                        }
                    ]
                },
                {
                    path: "/membership",
                    label: "Memberships",
                    icon: <Icon icon="mdi:card-account-details" width="20" height="20" />,
                },
                {
                    path: "/coupons",
                    label: "Coupons",
                    icon: <Icon icon="mdi:coupon" width="20" height="20" />,
                },
                {
                    path: "/campaigns",
                    label: "Campaigns",
                    icon: <Icon icon="mdi:bullhorn-outline" width="20" height="20" />,
                    subItems: [
                        {
                            path: "/campaigns",
                            label: "All Campaigns",
                            icon: <Icon icon="mdi:view-list" width="18" height="18" />,
                        },
                        {
                            path: "/campaigns/templates",
                            label: "Template Library",
                            icon: <Icon icon="mdi:file-document-multiple-outline" width="18" height="18" />,
                        },
                        {
                            path: "/campaigns/create",
                            label: "Create Campaign",
                            icon: <Icon icon="mdi:plus-circle-outline" width="18" height="18" />,
                        },
                        {
                            path: "/meta-config",
                            label: "Meta Configuration",
                            icon: <Icon icon="mdi:whatsapp" width="18" height="18" />,
                        },
                        ...((role === "SuperAdmin" || role === "SelfAdmin") ? [
                            {
                                path: "/whatsapp-usage",
                                label: "WhatsApp Quotas",
                                icon: <Icon icon="mdi:chart-box-outline" width="18" height="18" />,
                            }
                        ] : [])
                    ]
                },

            ]
            : []),

        // Common for allowed roles
        ...(role === "Biller" ? [
            {
                path: "/pos",
                label: "POS",
                icon: <Icon icon="mdi:cash-register" width="20" height="20" />,
            },
        ] : []),
        {
            path: "/appointments",
            label: "Appointment",
            icon: <Icon icon="mdi:calendar-heart" width="20" height="20" />,
        },
        {
            path: "/appointmentcalender",
            label: "Appointment Calendar",
            icon: <Icon icon="mdi:calendar-month" width="20" height="20" />,
        },
        {
            path: "/return",
            label: "Return",
            icon: <Icon icon="mdi:keyboard-return" width="20" height="20" />,
        },
        {
            path: "/sales",
            label: "Sales",
            icon: <Icon icon="mdi:graph-line" width="20" height="20" />,
        },
        {
            path: "/purchases",
            label: "Purchase",
            icon: <Icon icon="mdi:shopping-cart-arrow-down" width="20" height="20" />,
        },
        {
            path: "/suppliers",
            label: "Suppliers",
            icon: <Icon icon="mdi:account-tie" width="20" height="20" />,
        },
        {
            path: "/inventories",
            label: "Inventory",
            icon: <Icon icon="mdi:warehouse" width="20" height="20" />,
        },
        {
            path: "/expense",
            label: "Expense",
            icon: <Icon icon="mdi:money-100" width="20" height="20" />,
        },
        {
            path: "/logout",
            label: "Logout",
            icon: <Icon icon="mdi:logout-variant" width="20" height="20" />,
        },
    ];
};

